/**
 * Familles de guides (filtres de /guides).
 * Module léger, séparé du corpus `guides.ts` pour ne pas alourdir le bundle.
 */
export type GuideFamily = {
  id: string;
  label: string;
  /** Slugs de guides rattachés à cette famille. */
  slugs: string[];
};

export const guideFamilies: GuideFamily[] = [
  { id: "mafia", label: "Mafia & banditisme", slugs: ["mafia-corse-documentaire", "omerta-brise-de-mer"] },
  { id: "flnc", label: "FLNC & nationalisme", slugs: ["flnc-documentaire"] },
  { id: "histoire", label: "Histoire", slugs: ["histoire-de-la-corse"] },
  { id: "yvan-colonna", label: "Yvan Colonna", slugs: ["yvan-colonna"] },
  { id: "chant", label: "Chant & culture", slugs: ["chant-corse"] },
  { id: "cinema", label: "Cinéma & fiction", slugs: ["film-corse-netflix"] },
  {
    id: "politique",
    label: "Politique & institutions",
    slugs: ["autonomie-corse", "assemblee-de-corse", "elections-territoriales-corse"],
  },
  { id: "sport", label: "Sport, rallye & trail", slugs: ["tour-de-corse", "gr20-trail"] },
  { id: "replay", label: "Replay & reportages", slugs: ["corse-replay", "reportage-corse", "documentaire-corse", "documentaire-corse-replay"] },

];
